/* Sawtooth STRETCH – shared behaviors for all STX sections.
   Works on document-level hooks, so each section can be used on its own. */
(function () {
  'use strict';
  if (window.__stxLoaded) return;
  window.__stxLoaded = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Truck finder data (from the STX Truck finder section) ---------- */
  var makes = [], models = {};
  function loadFitData() {
    makes = []; models = {};
    var holder = $('[data-fit-data]');
    if (!holder) return;
    (holder.getAttribute('data-fit-data') || '').split(/\r?\n/).forEach(function (line) {
      var p = line.split('|').map(function (s) { return s.trim(); });
      if (p.length < 2 || !p[0] || !p[1]) return;
      if (!models[p[0]]) { models[p[0]] = []; makes.push(p[0]); }
      models[p[0]].push({ model: p[1], url: p[2] || '/collections/all' });
    });
  }
  function opt(value, label) { var o = document.createElement('option'); o.value = value; o.textContent = label || value; return o; }

  function fillModels(makeSel, modelSel) {
    var list = models[makeSel.value] || [];
    modelSel.innerHTML = '';
    if (!list.length) { modelSel.appendChild(opt('', 'Choose make first')); modelSel.disabled = true; return; }
    modelSel.appendChild(opt('', 'Choose model'));
    list.forEach(function (i) { modelSel.appendChild(opt(i.url, i.model)); });
    modelSel.disabled = false;
  }
  function feedback(form) {
    var fb = $('.fit-feedback', form), mk = $('[data-stx-make]', form), md = $('[data-stx-model]', form);
    if (!fb || !mk || !md) return;
    if (!mk.value) fb.textContent = 'Select your truck to see the next step.';
    else if (!md.value) fb.textContent = 'Now choose your model.';
    else fb.textContent = 'Next: confirm your year and bed length for the ' + mk.value + ' ' + md.options[md.selectedIndex].text + '.';
  }

  /* ---------- Dialog helpers ---------- */
  function openDialog(d) {
    if (!d) return;
    if (typeof d.showModal === 'function') { if (!d.open) d.showModal(); } else d.setAttribute('open', '');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeDialog(d) { if (d) { if (typeof d.close === 'function') d.close(); else d.removeAttribute('open'); } }

  function initDialogs() {
    $$('.stx dialog').forEach(function (d) {
      if (d.dataset.stxDlg) return; d.dataset.stxDlg = '1';
      d.addEventListener('click', function (e) { if (e.target === d) closeDialog(d); });
      d.addEventListener('close', function () {
        document.documentElement.style.overflow = '';
        var v = $('video', d); if (v) v.pause();
        var pl = $('#stx-film-player', d); if (pl) pl.innerHTML = '';
      });
      var x = $('.dialog-close', d); if (x) x.addEventListener('click', function () { closeDialog(d); });
    });
  }

  /* ---------- Populate make lists / buttons ---------- */
  function populateMakes() {
    $$('select[data-stx-make]').forEach(function (sel) {
      if (sel.options.length > 1) return;
      makes.forEach(function (m) { sel.appendChild(opt(m)); });
    });
    $$('[data-make-buttons]').forEach(function (box) {
      if (box.children.length) return;
      makes.forEach(function (m) {
        var b = document.createElement('button');
        b.type = 'button'; b.textContent = m; b.setAttribute('data-fit', ''); b.setAttribute('data-make', m);
        box.appendChild(b);
      });
    });
  }

  /* ---------- Hero inline video ---------- */
  function toggleHero(hero, show) {
    var panel = $('[data-stx-hero-panel]', hero), video = $('[data-stx-hero-video]', hero);
    var img = $('.hero-truck', hero), play = $('[data-stx-hero-play]', hero);
    if (!panel || !video) return;
    panel.hidden = !show; if (img) img.hidden = show;
    if (play) play.setAttribute('aria-expanded', String(show));
    if (show) { video.load(); var p = video.play(); if (p && p.catch) p.catch(function () {}); } else video.pause();
  }

  /* ---------- Menu ---------- */
  function setMenu(btn, open) {
    var menu = document.getElementById(btn.getAttribute('aria-controls'));
    if (!menu) return;
    menu.hidden = !open; btn.setAttribute('aria-expanded', String(open)); btn.classList.toggle('is-open', open);
  }

  /* ---------- Global click delegation ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var fit = t.closest('[data-fit]');
    if (fit && fit.closest('.stx')) {
      var dlg = document.getElementById('stx-fit-dialog');
      if (!dlg) { window.location.href = '/collections/all'; return; }
      e.preventDefault();
      var form = $('[data-stx-fit-form]', dlg), mk = $('[data-stx-make]', form), md = $('[data-stx-model]', form);
      var make = fit.getAttribute('data-make');
      mk.value = make && models[make] ? make : '';
      fillModels(mk, md); feedback(form);
      $$('[data-stx-menu-toggle][aria-expanded="true"]').forEach(function (b) { setMenu(b, false); });
      openDialog(dlg); return;
    }
    var menuBtn = t.closest('[data-stx-menu-toggle]');
    if (menuBtn) { setMenu(menuBtn, menuBtn.getAttribute('aria-expanded') !== 'true'); return; }
    var mobileLink = t.closest('.mobile-nav a');
    if (mobileLink) { $$('[data-stx-menu-toggle]').forEach(function (b) { setMenu(b, false); }); return; }

    var hp = t.closest('[data-stx-hero-play]');
    if (hp) { var h = hp.closest('.hero'); var panel = $('[data-stx-hero-panel]', h); toggleHero(h, panel.hidden); return; }
    var hc = t.closest('[data-stx-hero-close]');
    if (hc) { toggleHero(hc.closest('.hero'), false); return; }

    var demo = t.closest('[data-stx-demo]');
    if (demo) {
      var vd = document.getElementById('stx-video-dialog'), v = document.getElementById('stx-product-video');
      if (!vd || !v) return;
      var src = demo.getAttribute('data-video-src');
      if (src && v.getAttribute('src') !== src) v.setAttribute('src', src);
      openDialog(vd); var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); return;
    }

    var film = t.closest('[data-stx-film]');
    if (film) {
      var fd = document.getElementById('stx-film-dialog'), pl = document.getElementById('stx-film-player');
      if (!fd || !pl) return;
      var id = film.getAttribute('data-film-id');
      if (id) {
        pl.innerHTML = '<iframe src="https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0" title="Product film" allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen></iframe>';
        var link = $('[data-film-link]', fd); if (link) { link.href = 'https://www.youtube.com/watch?v=' + encodeURIComponent(id); link.hidden = false; }
      }
      openDialog(fd);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') $$('[data-stx-menu-toggle][aria-expanded="true"]').forEach(function (b) { setMenu(b, false); });
  });

  /* ---------- Make/model selects + form submit ---------- */
  document.addEventListener('change', function (e) {
    var mk = e.target.closest && e.target.closest('select[data-stx-make]');
    var md = e.target.closest && e.target.closest('select[data-stx-model]');
    var form = e.target.closest && e.target.closest('form');
    if (mk && form) { fillModels(mk, $('[data-stx-model]', form)); feedback(form); }
    else if (md && form) feedback(form);
  });
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-stx-fit-form], [data-stx-closing-form]')) return;
    e.preventDefault();
    var md = $('[data-stx-model]', form);
    if (md && md.value) window.location.href = md.value;
  });

  /* ---------- FAQ: one open at a time ---------- */
  function initFaq() {
    $$('.faq-list').forEach(function (list) {
      if (list.dataset.stxFaq) return; list.dataset.stxFaq = '1';
      var items = $$('details', list);
      items.forEach(function (d) {
        d.addEventListener('toggle', function () { if (d.open) items.forEach(function (o) { if (o !== d) o.open = false; }); });
      });
    });
  }

  /* ---------- Scroll-driven sequence ---------- */
  function initSequence() {
    $$('.scroll-sequence').forEach(function (root) {
      if (root.dataset.stxSeq) return; root.dataset.stxSeq = '1';
      var chapters = $$('.sequence-chapter', root), frames = $$('.sequence-frame', root);
      var links = $$('[data-sequence-step]', root), count = $('.sequence-count', root);
      var pad = function (n) { return ('0' + n).slice(-2); };
      frames.forEach(function (f) {
  var im = f.querySelector('img');
  if (!im) return;
  im.loading = 'eager';
  im.decoding = 'async';
  if (im.decode) im.decode().catch(function () {});
});
     var currentStep = -1;
function setStep(i) {
  if (i < 0 || i >= chapters.length || i === currentStep) return;
  currentStep = i;

        chapters.forEach(function (c, n) { c.classList.toggle('is-current', n === i); });
        frames.forEach(function (f, n) { f.classList.toggle('is-current', n === i); f.setAttribute('aria-hidden', String(n !== i)); });
        links.forEach(function (a, n) { a.classList.toggle('is-active', n === i); if (n === i) a.setAttribute('aria-current', 'step'); else a.removeAttribute('aria-current'); });
        if (count) count.textContent = pad(i + 1) + ' / ' + pad(chapters.length);
      }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { if (en.isIntersecting) setStep(chapters.indexOf(en.target)); });
        }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
        chapters.forEach(function (c) { io.observe(c); });
      }
      links.forEach(function (a) {
        a.addEventListener('click', function (e) {
          e.preventDefault();
          var i = parseInt(a.getAttribute('data-sequence-step'), 10);
          if (chapters[i]) chapters[i].scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
          setStep(i);
        });
      });
      setStep(0);
    });
  }



  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    var els = $$('.reveal:not(.is-in)');
    if ('IntersectionObserver' in window && !reduceMotion) {
      var io = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); obs.unobserve(en.target); } });
      }, { threshold: 0.15 });
      els.forEach(function (el) { io.observe(el); });
    } else els.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- Sticky mobile CTA ---------- */
  function initMobileBar() {
    var bar = $('.mobile-fit'); if (!bar || bar.dataset.stxBar || !('IntersectionObserver' in window)) return;
    bar.dataset.stxBar = '1';
    var hero = $('.hero'), closing = $('.closing'), heroGone = !hero, closingSeen = false;
    var sync = function () { bar.classList.toggle('is-visible', heroGone && !closingSeen); };
    if (hero) new IntersectionObserver(function (e) { heroGone = !e[0].isIntersecting && e[0].boundingClientRect.top < 0; sync(); }).observe(hero);
    if (closing) new IntersectionObserver(function (e) { closingSeen = e[0].isIntersecting; sync(); }).observe(closing);
    sync();
  }

  function boot() {
    $$('.stx').forEach(function (el) { el.classList.add('js'); });
    loadFitData(); populateMakes(); initDialogs(); initFaq(); initSequence(); initReveal(); initMobileBar();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', function () { setTimeout(function () { loadFitData(); }, 0); });
})();
